<template>
  <div>
    <el-dialog
      top="10vh"
      @close="close()"
      :title="title_modal"
      width="70%"
      :visible.sync="show"
      center
    >
    <div
        class="col-md-12"
        v-loading="loading"
        element-loading-text="Guardando por favor espere"
      >
        <form @submit.prevent="storeItem()">
          <div class="row">
            <div class="card vx-card">
              <div class="card-header bg-white">
                <h4 class="">Información Artículo</h4>
              </div>

              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Imagen </label>
                      <small class="text-primary">
                        Para cambiar la imagen elige uno nuevo.</small
                      >
                      <el-image
                        style="width: 100px; height: 100px; display: block"
                        :src="item.image"
                        fit="scale-down"
                      ></el-image>
                      <el-upload
                        ref="upload"
                        action="#"
                        :auto-upload="false"
                        :limit="1"
                        :on-change="logoSelect"
                        :on-exceed="logoExceed"
                        :on-remove="logoRemove"
                        :file-list="fileList"
                        :multiple="false"
                      >
                        <el-button slot="trigger" size="small" type="primary"
                          >Subir Imagen</el-button
                        >
                      </el-upload>
                    </div>

                    <div class="form-group">
                      <label>Código Cabys</label>
                      <el-select
                        placeholder=""
                        v-model="item.cabys_code"
                        value-key="id"
                        name="cabys_code"
                        filterable
                        class="form-control items"
                        popper-class="el-select-float"
                        data-vv-as="Código Cabys"
                        remote
                        :remote-method="searchCabysCodes"
                        :loading="loadingSearch"
                        @change="changeTaxType"
                      >
                        <el-option
                          v-for="cabys in cabysCodes"
                          :key="cabys.id"
                          :label="`${cabys.code}-${cabys.name}`"
                          :value="cabys"
                        >
                          <span style="font-weight: bold;">{{
                            cabys.code
                          }}</span
                          >-{{ cabys.name }}
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('cabys_code')" class="error">
                        {{ errors.first("cabys_code") }}
                      </label>
                    </div>

                    <text-input
                      name="code"
                      :label="'Código Interno'"
                      v-validate="'required'"
                      :error="errors.first('code')"
                      v-model="item.code"
                      data-vv-as="Código Interno"
                    >
                    </text-input>
                    <text-input
                      name="sku"
                      :label="'SKU'"
                      :error="errors.first('sku')"
                      v-model="item.sku"
                      data-vv-as="SKU"
                    >
                    </text-input>
                    <text-input
                      name="barcode"
                      :label="'Código de barras'"
                      :error="errors.first('barcode')"
                      v-model="item.barcode"
                      data-vv-as="Código de barras"
                    >
                    </text-input>
                    <text-input
                      name="reference"
                      :label="'Referencia'"
                      :error="errors.first('reference')"
                      v-model="item.reference"
                      data-vv-as="Referencia"
                    >
                    </text-input>
                    <text-input
                      name="name"
                      :label="'Nombre del Producto'"
                      v-validate="'required'"
                      :error="errors.first('name')"
                      v-model="item.name"
                      data-vv-as="Nombre del Producto"
                    >
                    </text-input>

                    <div class="form-group">
                      <label>Categoría Hacienda</label>
                      <el-select
                        placeholder=""
                        v-model="item.category"
                        value-key="id"
                        name="category"
                        v-validate="'required'"
                        filterable
                        class="form-control"
                        popper-class="el-select-float"
                      >
                        <el-option
                          v-for="category in categories"
                          :key="category.id"
                          :label="category.name"
                          :value="category"
                        >
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('category')" class="error">
                        {{ errors.first("category") }}
                      </label>
                    </div>

                    <div class="form-group">
                      <label>Unidades de Medida</label>
                      <el-select
                        placeholder=""
                        v-model="item.unit"
                        value-key="id"
                        name="unit"
                        v-validate="'required'"
                        filterable
                        class="form-control"
                        popper-class="el-select-float"
                      >
                        <el-option
                          v-for="unit in units"
                          :key="unit.id"
                          :label="unit.description"
                          :value="unit"
                        >
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('unit')" class="error">
                        {{ errors.first("unit") }}
                      </label>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>IVA</label>
                      <el-select
                        popper-class="el-select-float"
                        no-data-text="No hay datos."
                        no-match-text="No hay resultados."
                        placeholder=""
                        v-model="item.tax_type"
                        value-key="id"
                        name="tax_type"
                        v-validate="'required'"
                        filterable
                        class="form-control"
                        @change="getUtility"
                      >
                        <el-option
                          v-for="tax_type in tax_types"
                          :key="tax_type.id"
                          :label="tax_type.name"
                          :value="tax_type"
                        >
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('tax_type')" class="error">
                        {{ errors.first("tax_type") }}
                      </label>
                    </div>

                    <div class="form-group">
                      <label>Moneda</label>
                      <el-select
                        popper-class="el-select-float"
                        placeholder=""
                        no-data-text="No hay datos."
                        no-match-text="No hay resultados."
                        v-model="item.currency"
                        value-key="id"
                        name="currency"
                        v-validate="'required'"
                        filterable
                        class="form-control"
                      >
                        <el-option
                          v-for="currency in currencies"
                          :key="currency.id"
                          :label="`${currency.name} (${currency.symbol})`"
                          :value="currency"
                        >
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('currency')" class="error">
                        {{ errors.first("currency") }}
                      </label>
                    </div>

                    <text-input
                      name="cost_price"
                      :label="'Precio costo'"
                      v-validate="'decimal:2'"
                      :error="errors.first('cost_price')"
                      v-model="item.cost_price"
                      data-vv-as="Precio costo"
                      @change="getUtility"
                    >
                    </text-input>

                    <text-input
                      name="utility"
                      :label="'Utilidad (%)'"
                      v-validate="'decimal:2'"
                      :error="errors.first('utility')"
                      v-model="item.utility"
                      :disabled="true"
                      data-vv-as="Utilidad"
                    >
                    </text-input>

                    <text-input
                      name="price"
                      :label="'Precio sin IVA'"
                      v-validate="'required|decimal:2'"
                      :error="errors.first('price')"
                      v-model="item.price"
                      data-vv-as="Precio"
                      @change="getUtility"
                    >
                    </text-input>

                    <text-input
                      name="sale_price"
                      :label="'Precio Venta'"
                      v-validate="'required|decimal:2'"
                      :error="errors.first('sale_price')"
                      v-model="item.sale_price"
                      data-vv-as="Precio Venta"
                      @change="getPrice"
                    >
                    </text-input>

                    <text-input
                      name="max_discount"
                      :label="'Descuento Máximo (%)'"
                      v-validate="'required|decimal:2'"
                      :error="errors.first('max_discount')"
                      v-model="item.max_discount"
                      data-vv-as="Descuento Máximo"
                    >
                    </text-input>

                    <text-input
                      name="stock"
                      :label="'Existencia'"
                      :error="errors.first('stock')"
                      v-model="item.stock"
                      data-vv-as="Existencia"
                      :disabled="true"
                    >
                    </text-input>

                    <div class="form-group">
                      <label>Marca</label>
                      <el-select
                        popper-class="el-select-float"
                        placeholder=""
                        v-model="item.brand"
                        value-key="id"
                        name="brand"
                        filterable
                        class="form-control"
                      >
                        <el-option
                          v-for="brand in brands"
                          :key="brand.id"
                          :label="brand.name"
                          :value="brand"
                        >
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('brand')" class="error">
                        {{ errors.first("brand") }}
                      </label>
                    </div>

                    <div class="form-group">
                      <label>Familia</label>
                      <el-select
                        popper-class="el-select-float"
                        placeholder=""
                        v-model="item.family"
                        value-key="id"
                        name="family"
                        filterable
                        class="form-control"
                      >
                        <el-option
                          v-for="family in families"
                          :key="family.id"
                          :label="family.name"
                          :value="family"
                        >
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('family')" class="error">
                        {{ errors.first("family") }}
                      </label>
                    </div>

                    <el-checkbox
                      v-show="item.category.id == 1"
                      v-model="item.has_inventory"
                      >Llevar inventario
                    </el-checkbox>

                    <el-checkbox v-model="item.active">Activo </el-checkbox>
                  </div>

                  <div class="col-md-12 text-center p-t-20">
                    <text-input
                      name="description"
                      :label="'Detalles'"
                      v-validate="'required'"
                      :error="errors.first('description')"
                      v-model="item.description"
                      data-vv-as="Detalles"
                      :textArea="true"
                    >
                    </text-input>

                    <vs-button button="submit" color="primary" type="filled">
                      <i class="fa fa-save"></i>
                      Guardar
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import itemsService from "@/services/items.service.js";
import brandsService from "@/services/brands.service.js";
import familiesService from "@/services/families.service.js";
import utilitiesService from "@/services/utilities.service";
import { mapState, mapActions } from "vuex";
import Config from "@/config";

export default {
  name: "new-item-2",
  props: {
    vis: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      cabysCodes: [],
      loadingSearch: false,
      loading: false,
      item: {
        cabys_code: "",
        code: "",
        name: "",
        description: "",
        category: {id: 1, name: "Productos"},
        unit: {id: 37, name: "Unidad"},
        tax_type: "",
        price: "",
        currency: {id: 2, name: "Colones"},
        sku: "",
        barcode: "",
        reference: "",
        max_discount: "",
        brand: "",
        family: "",
        cost_price: "",
        sale_price: "",
        stock: "",
        utility: "",
        has_inventory: false,
        active: true,
        image: "",
        image_file: null,
      },
      brands: [],
      families: [],
      fileList: [],
    };
  },
  computed: {
    show: {
      get() {
        return this.vis;
      },
      set() {}
    },
    title_modal() {
      return "Nuevo articulo";
    },

    ...mapState(["categories", "units", "tax_types", "currencies"]),
    categories() {
      return this.$store.state.categories;
    },
    units() {
      return this.$store.state.units;
    },
    tax_types() {
      return this.$store.state.tax_types;
    },
    currencies() {
      return this.$store.state.currencies;
    },
    url_logo() {
      return Config.url_files;
    }
  },
  methods: {
    ...mapActions([
      "getCategories",
      "getUnits",
      "getTaxTypes",
      "getCurrencies"
    ]),
    logoSelect(file) {
      this.fileList.push(file);
      this.item.image_file = file.raw;
      this.item.image = file.raw;

      this.item.image = URL.createObjectURL(file.raw);
    },
    logoExceed(file) {
      this.fileList = [];
      this.item.image_file = file;

      this.fileList.push(file[0]);
      this.item.image = file[0];
    },
    logoRemove() {
      (this.item.image_file = null((this.fileList = []))),
        (this.item.image = null);
    },
    close() {
      this.resetForm()
      this.$emit("closeModal", false);
    },
    resetDataForm() {
      let data_form_initial = this.$options.data().patient;
      Object.assign(this.$data.patient, data_form_initial);
    },
    getBrands(page = 0) {
      brandsService
        .getBrands(page)
        .then(res => {
          this.brands = res.data;
        })
        .catch(error => {
          this.loading = false;
          if (error.response.status == 401) {
            // localStorage.clear();
            // this.$router.push('login');
          }
        });
    },
    getFamilies(page = 0) {
      familiesService
        .getFamilies(page)
        .then(res => {
          this.families = res.data;
        })
        .catch(error => {
          this.loading = false;
          if (error.response.status == 401) {
            // localStorage.clear();
            // this.$router.push('login');
          }
        });
    },
    getPrice() {
      if (this.item.tax_type && this.item.sale_price != ""){
        let price = this.item.sale_price * 100 / (100 + this.item.tax_type.rate * 1);
        this.item.price = price.toFixed(2);
        let result = (this.item.price / this.item.cost_price - 1) * 100;
        this.item.utility = result.toFixed(2);
      }
    },
    getUtility() {
      if (this.item.tax_type && this.item.price != ""){
        let sale_price = (this.item.price * 1 + (this.item.price * this.item.tax_type.rate / 100));
        this.item.sale_price = sale_price.toFixed(2);
      }
      if (
        this.item.cost_price != "" &&
        this.item.cost_price > 0 &&
        this.item.price != ""
      ) {
        let result = (this.item.price / this.item.cost_price - 1) * 100;
        this.item.utility = result.toFixed(2);
      }
    },
    storeItem() {
      this.$validator.validate().then(valid => {
        if (valid) {
          if (this.item.category.id != 1) {
            this.item.has_inventory = false;
          }
          
          let formData = new FormData();
          //Datos item
          Object.keys(this.item).forEach(key => {
            let value;
            if (
              typeof this.item[key] === "object" &&
              !(this.item[key] instanceof File)
            ) {
              value = JSON.stringify(this.item[key]);
            } else {
              value = this.item[key];
            }
            formData.append(key, value);
          });
          itemsService
            .storeItem(formData)
            .then(() => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: "Artículo Guardado correctamente",
                type: "success",
                duration: 1500
              });
              this.$emit("refresh", false);
              this.close();
            })
            .catch(function(error) {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error.response.data.message,
                type: "error"
              });
            });
        }
      });
    },
    searchCabysCodes(search) {
      this.loadingSearch = true;
      this.getCabysCodes(search);
    },
    //Get cabys codes
    getCabysCodes(search = false) {
      utilitiesService
        .getCabysCodes(search)
        .then(res => {
          this.loadingSearch = false;
          this.cabysCodes = res.data;
        })
        .catch(error => {
          this.loadingSearch = false;
          this.$message({
            showClose: true,
            message: error.response.data.message,
            type: "error"
          });
        });
    },
    getCategories() {
      this.$store.dispatch("getCategories", {});
    },
    getUnits() {
      this.$store.dispatch("getUnits", {});
    },
    getTaxTypes() {
      this.$store.dispatch("getTaxTypes", {});
    },
    getCurrencies() {
      this.$store.dispatch("getCurrencies", {});
    },
    changeTaxType(val) {
      let tt = this.tax_types.find(i => i.name == "Exento");
      if (val.tax_rate != "Exento") {
        tt = this.tax_types.find(i => i.rate == val.tax_rate);
      }
      this.item.tax_type = tt;
    },
    submit() {
      this.storeItem();
      this.close();
    },
    resetForm() {
      let data_form_initial = this.$options.data().item;
      Object.assign(this.$data.item, data_form_initial);
      this.$validator.reset();
    },
  },
  created() {
    this.resetForm()
    this.getCategories();
    this.getUnits();
    this.getTaxTypes();
    this.getCurrencies();
    this.getCabysCodes();
    this.getBrands();
    this.getFamilies();
  }
};
</script>

<style>
.box-shadow {
  box-shadow: 0 0 2px rgb(136, 124, 124) !important;
}

.oculto {
  display: none;
}

.con-vs-popup .vs-popup {
  width: 700px !important;
}

.el-select-dropdown__item {
  max-width: 600px;
  position: static;
  white-space: break-spaces;
  text-overflow: none;
  /* height: auto !important; */
  height: auto;
  max-height: 60px;
}
</style>
